import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, renderSlot as _renderSlot, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "group-invitation-ui"
};
var _hoisted_2 = {
  class: "my-1 pt-2 pb-4"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("Show unusable link");

var _hoisted_4 = {
  key: 0
};
var _hoisted_5 = {
  key: 1
};
var _hoisted_6 = {
  class: "pt-4"
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode("Create a new link");

var _hoisted_8 = /*#__PURE__*/_createTextVNode("Create a new one");

var _hoisted_9 = /*#__PURE__*/_createTextVNode(" Maximum invitations · ");

var _hoisted_10 = /*#__PURE__*/_createElementVNode("small", null, "(Optional)", -1);

var _hoisted_11 = /*#__PURE__*/_createTextVNode(" Expiration date · ");

var _hoisted_12 = /*#__PURE__*/_createElementVNode("small", null, "(Optional)", -1);

var _hoisted_13 = {
  class: "mt-3"
};

var _hoisted_14 = /*#__PURE__*/_createTextVNode(" Create ");

var _hoisted_15 = /*#__PURE__*/_createTextVNode("Try again");

var _hoisted_16 = {
  key: 1,
  class: "users"
};
import { reactive, ref, computed } from "vue";
import { DateTime } from "luxon";
import { orderBy } from "lodash";
import { useIsMobile } from "@/utils/reactive";
import { handleError } from "@/utils/errors";
import { InvitationModel, InvitationValidator } from "@/schemes/group";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import GroupInvitationLink from "@/components/groups/GroupInvitationLink.vue";
import InputNumber from "../utils/InputNumber.vue";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  props: {
    groupId: null
  },
  emits: ["fetched", "created", "removed"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var isMobile = useIsMobile();
    var LoaderState = LoaderStateEnum;
    var loaders = reactive({
      fetch: LoaderStateEnum.Loading,
      create: LoaderStateEnum.Idle
    });
    var errors = reactive({});
    var model = ref(_objectSpread({}, InvitationModel));
    var rules = InvitationValidator;
    var links = ref([]);
    var tab = ref("new");
    var showUnusable = ref(true);
    var form = ref(null);

    var load = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$http$get, resources;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loaders.fetch = LoaderStateEnum.Loading;
                _context.prev = 1;
                _context.next = 4;
                return http.get("/users/groupsinvitationlinks/".concat(props.groupId));

              case 4:
                _yield$http$get = _context.sent;
                resources = _yield$http$get.data;
                links.value = resources;
                emit("fetched", resources);

                if (links.value.length > 0) {
                  tab.value = "list";
                }

                loaders.fetch = LoaderStateEnum.Loaded;
                _context.next = 18;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);
                _context.next = 16;
                return handleError(_context.t0, {
                  placeholder: "The requested data is currently inaccessible."
                });

              case 16:
                errors.fetch = _context.sent;
                loaders.fetch = LoaderStateEnum.Failed;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 12]]);
      }));

      return function load() {
        return _ref2.apply(this, arguments);
      };
    }();

    var sorted = computed(function () {
      return orderBy(links.value, function (l) {
        return DateTime.fromISO(l.creationDate, {
          zone: "UTC"
        }).toMillis();
      }, "desc");
    });
    var usable = computed(function () {
      return sorted.value.filter(function (l) {
        return (typeof l.maxInvitations !== "number" || l.usedInvitations < l.maxInvitations) && (!l.expirationDate || DateTime.fromISO(l.expirationDate, {
          zone: "UTC"
        }) > DateTime.now());
      });
    });

    var create = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var payload, _yield$http$post, link;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (form.value) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return form.value.validate();

              case 5:
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](2);
                return _context2.abrupt("return", false);

              case 10:
                loaders.create = LoaderStateEnum.Loading;
                _context2.prev = 11;
                payload = {
                  nbInvitations: model.value.nbInvitations,
                  expirationTS: model.value.expirationDate
                };

                if (payload.expirationTS) {
                  payload.expirationDate = DateTime.fromMillis(payload.expirationTS).endOf("day").toISO();
                  delete payload.expirationTS;
                }

                _context2.next = 16;
                return http.post("/groups/".concat(props.groupId, "/invitationlink"), payload);

              case 16:
                _yield$http$post = _context2.sent;
                link = _yield$http$post.data;
                links.value.push(link);
                emit("created", link);
                tab.value = "list";
                model.value = _objectSpread({}, InvitationModel);
                loaders.create = LoaderStateEnum.Loaded;
                _context2.next = 31;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t1 = _context2["catch"](11);
                _context2.next = 29;
                return handleError(_context2.t1);

              case 29:
                errors.create = _context2.sent;
                loaders.create = LoaderStateEnum.Failed;

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 7], [11, 25]]);
      }));

      return function create() {
        return _ref3.apply(this, arguments);
      };
    }();

    var removed = function removed(link) {
      links.value = links.value.filter(function (l) {
        return l.invitationId !== link.invitationId;
      });
      emit("removed", link);
    };

    load();
    return function (_ctx, _cache) {
      var _component_n_switch = _resolveComponent("n-switch");

      var _component_n_space = _resolveComponent("n-space");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_empty = _resolveComponent("n-empty");

      var _component_n_tab_pane = _resolveComponent("n-tab-pane");

      var _component_n_input_number = _resolveComponent("n-input-number");

      var _component_n_form_item = _resolveComponent("n-form-item");

      var _component_n_date_picker = _resolveComponent("n-date-picker");

      var _component_n_alert = _resolveComponent("n-alert");

      var _component_n_form = _resolveComponent("n-form");

      var _component_n_tabs = _resolveComponent("n-tabs");

      var _component_n_result = _resolveComponent("n-result");

      var _component_n_skeleton = _resolveComponent("n-skeleton");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(loaders).fetch !== _unref(LoaderState).Loading ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(loaders).fetch !== _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_tabs, {
        key: 0,
        value: tab.value,
        "onUpdate:value": _cache[7] || (_cache[7] = function ($event) {
          return tab.value = $event;
        }),
        type: "segment"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_tab_pane, {
            name: "list",
            tab: "My links",
            disabled: _unref(loaders).create === _unref(LoaderState).Loading
          }, {
            default: _withCtx(function () {
              return [links.value.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_n_space, null, {
                default: _withCtx(function () {
                  return [_hoisted_3, _createVNode(_component_n_switch, {
                    value: showUnusable.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                      return showUnusable.value = $event;
                    })
                  }, null, 8, ["value"])];
                }),
                _: 1
              })]), showUnusable.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sorted), function (link) {
                return _openBlock(), _createBlock(GroupInvitationLink, {
                  "with-actions": true,
                  link: link,
                  key: link.invitationId,
                  onRemoved: removed
                }, null, 8, ["link"]);
              }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(usable), function (link) {
                return _openBlock(), _createBlock(GroupInvitationLink, {
                  "with-actions": true,
                  link: link,
                  key: link.invitationId,
                  onRemoved: removed
                }, null, 8, ["link"]);
              }), 128))])), _createElementVNode("div", _hoisted_6, [_createVNode(_component_n_button, {
                block: "",
                type: "info",
                size: "large",
                class: "px-5",
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return tab.value = 'new';
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_7];
                }),
                _: 1
              })])], 64)) : (_openBlock(), _createBlock(_component_n_empty, {
                key: 1,
                description: "You have not created any invitation link for this group yet.",
                class: "text-center py-4"
              }, {
                extra: _withCtx(function () {
                  return [_createVNode(_component_n_button, {
                    secondary: "",
                    type: "info",
                    onClick: _cache[2] || (_cache[2] = function ($event) {
                      return tab.value = 'new';
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_8];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }))];
            }),
            _: 1
          }, 8, ["disabled"]), _createVNode(_component_n_tab_pane, {
            name: "new",
            tab: "New link",
            class: "pt-4"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_form, {
                ref_key: "form",
                ref: form,
                model: model.value,
                rules: _unref(rules)
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_n_form_item, {
                    path: "nbInvitations"
                  }, {
                    label: _withCtx(function () {
                      return [_hoisted_9, _hoisted_10];
                    }),
                    default: _withCtx(function () {
                      return [_createVNode(InputNumber, {
                        "input-props": _unref(isMobile) ? {
                          pattern: '[0-9]*'
                        } : undefined,
                        class: "w-100"
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_n_input_number, {
                            value: model.value.nbInvitations,
                            "onUpdate:value": _cache[3] || (_cache[3] = function ($event) {
                              return model.value.nbInvitations = $event;
                            }),
                            min: _unref(rules).nbInvitations.min,
                            step: 1,
                            clearable: "",
                            onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"]))
                          }, null, 8, ["value", "min"])];
                        }),
                        _: 1
                      }, 8, ["input-props"])];
                    }),
                    _: 1
                  }), _createVNode(_component_n_form_item, {
                    path: "expirationDate"
                  }, {
                    label: _withCtx(function () {
                      return [_hoisted_11, _hoisted_12];
                    }),
                    default: _withCtx(function () {
                      return [_createVNode(_component_n_date_picker, {
                        value: model.value.expirationDate,
                        "onUpdate:value": _cache[5] || (_cache[5] = function ($event) {
                          return model.value.expirationDate = $event;
                        }),
                        type: "date",
                        clearable: "",
                        class: "w-100",
                        onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"])),
                        "input-readonly": _unref(isMobile)
                      }, null, 8, ["value", "input-readonly"])];
                    }),
                    _: 1
                  }), _renderSlot(_ctx.$slots, "action", {
                    loader: _unref(loaders).create
                  }, function () {
                    return [_createElementVNode("div", _hoisted_13, [_createVNode(_component_n_button, {
                      type: "primary",
                      size: "large",
                      block: "",
                      loading: _unref(loaders).create === _unref(LoaderState).Loading,
                      onClick: create
                    }, {
                      default: _withCtx(function () {
                        return [_hoisted_14];
                      }),
                      _: 1
                    }, 8, ["loading"])])];
                  }), _unref(loaders).create === _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_alert, {
                    key: 0,
                    type: "error",
                    class: "white-space-pre-line mt-4",
                    "show-icon": false
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_unref(errors).create), 1)];
                    }),
                    _: 1
                  })) : _createCommentVNode("", true)];
                }),
                _: 3
              }, 8, ["model", "rules"])];
            }),
            _: 3
          })];
        }),
        _: 3
      }, 8, ["value"])) : (_openBlock(), _createBlock(_component_n_result, {
        key: 1,
        status: "error",
        title: "Error",
        class: "pt-2 pb-4",
        description: _unref(errors).fetch
      }, {
        footer: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            onClick: load
          }, {
            default: _withCtx(function () {
              return [_hoisted_15];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["description"]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_n_skeleton, {
        class: "mb-3",
        size: "large",
        repeat: 3
      })]))]);
    };
  }
});